/**
 * Ryan O'Dowd
 * 2025-05-15
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, windowHeight, safeAreaInsets}) => {
  return {
    contentWrapper: {
      display: 'flex',
      // @TODO: min width for web?
      maxHeight: Math.min(700, windowHeight - safeAreaInsets.top - safeAreaInsets.bottom - 340), // @TODO: in here just for desktop and mobile (mobile is too tall, web is too narrow/short)
      justifyContent: 'center',
      alignItems: 'center',
    },
    fullImage: {
      display: 'flex',
      width: '100%',
      height: '100%',
      minWidth: 400,
      minHeight: 400,
      maxWidth: '100%',
      maxWeight: '100%',
      aspectRatio: 1,
      borderRadius: globalScale * 8,
      objectFit: 'contain',
    },
    title: {
      marginTop: globalScale * 8,
      marginBottom: 0,
    },
    closeButtonWrapper: {
      width: '100%',
      alignItems: 'flex-end',
    },
  };
};

export default getStyles;
